export const TX_STATUS = ["Success", "Failed", "Pending", "Refund", "all"];
export const TRON = "tron";
export const EXPLORER_STATUS = [
  "operational",
  "degraded",
  "downtime",
  "maintenance",
];
